
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/metrics",
      function () {
        return require("private-next-pages/metrics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/metrics"])
      });
    }
  